import React from "react";
import "./RentTypeAbout.css";
import RentTypeLogo from "../../../assets/renttypelogo.png";

function RentTypeAbout() {
  return (
    <div className="Rent-Type-About-Page-1-container">
      <div className="Rent-Type-About-Page-1-content">
        <div className="Rent-Type-About-Page-1-text-container">
          <h1 className="Rent-Type-About-Page-1-main-title">RentType.com</h1> 
          <p className="Rent-Type-About-Page-1-descriptions">
            Embark on an extraordinary voyage through RentType.com, a realm
            where mobility transcends function and becomes an embodiment of
            lifestyle.
            <br />
            <br />
            Our platform unfurls a dimension where vehicle rentals evolve into
            boundless expeditions, where each vehicle, whether car or van,
            unfurls as a canvas of endless possibilities.
            <br />
            <br />
            The interface is not just user-friendly; it's a tribute to future
            convenience.
            <br />
            <br />
            With a meticulously curated array of vehicles and a seamless user
            experience, RentType.com transforms into an artist's palette where
            journeys are painted with meticulous care.
            <br />
            <br />
            Trust here is not an endpoint; it's the very vehicle bridging
            destinations, inviting you to embrace unparalleled experiences.
          </p>
        </div>
        <div className="Rent-Type-About-Page-1-logo-container">
          <a href="http://renttype.com/" target="_blank" rel="noopener noreferrer">
            <img
              src={RentTypeLogo}
              alt="RentType Logo"
              className="Rent-Type-About-Page-1-logo"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default RentTypeAbout;
